import * as React from 'react';
import { UitkHeading } from 'uitk-react-text';
import { UitkSpacing } from 'uitk-react-spacing';
import { useStores } from '../../../utils/hooks';
import { ActivityKeywordSearchInput } from '../../common/activity-keyword-search-input';
import { Checkbox } from './checkbox';
import { Radio } from './radio';
export var Filter = function (_a) {
  var _b;
  var inDialog = _a.inDialog;
  var activitySearchStore = useStores().activitySearchStore;
  var filterSections = (_b = activitySearchStore.universalSortAndFilter) === null || _b === void 0 ? void 0 : _b.filterSections;
  if (!filterSections) {
    return React.createElement(React.Fragment, null);
  }
  var getTestID = function (field) {
    var _a;
    var testId = '';
    if (field.__typename === 'ShoppingTextInputField') {
      testId = field.id;
    } else if (field.__typename === 'ShoppingMultiSelectionField' || field.__typename === 'ShoppingSelectionField') {
      testId = field.options ? (_a = field.options[0]) === null || _a === void 0 ? void 0 : _a.id : testId;
    }
    return testId;
  };
  var sortAndFilterFields = function (field) {
    switch (field.__typename) {
      case 'ShoppingTextInputField':
        return React.createElement(ActivityKeywordSearchInput, {
          inDialog: inDialog
        });
      case 'ShoppingSelectionField':
        return React.createElement(Radio, {
          inDialog: inDialog,
          field: field
        });
      case 'ShoppingMultiSelectionField':
        return React.createElement(Checkbox, {
          inDialog: inDialog,
          field: field
        });
      default:
        return React.createElement(React.Fragment, null);
    }
  };
  return React.createElement(React.Fragment, null, filterSections.map(function (filterSection, index) {
    return React.createElement(UitkSpacing, {
      key: index,
      margin: {
        blockend: 'four'
      },
      padding: {
        blockend: 'four'
      }
    }, React.createElement("section", {
      className: "uitk-card-separator-bottom"
    }, filterSection.title && React.createElement(UitkSpacing, {
      padding: {
        blockend: 'two'
      }
    }, React.createElement(UitkHeading, {
      tag: "h2",
      size: 5,
      "data-testid": "filter-section--header"
    }, filterSection.title)), filterSection === null || filterSection === void 0 ? void 0 : filterSection.fields.map(function (field, i) {
      return React.createElement("div", {
        key: "".concat(getTestID(field), "-").concat(i),
        "data-testid": "sort-filter-".concat(getTestID(field), "-field")
      }, sortAndFilterFields(field));
    })));
  }));
};